export const PAGINATION = {
  page: 1,
  size: 10,
}

export const COUPON_TYPE_OPTIONS = [
  { label: '普通体验金', value: 'NORMAL_EXPERIENCE' },
  { label: '任务体验金', value: 'TASK_EXPERIENCE' },
  { label: '普通手续费抵扣券', value: 'NORMAL_FEE_DEDUCT' },
  { label: '任务手续费抵扣券', value: 'TASK_FEE_DEDUCT' },
  { label: '普通盈亏抵扣券', value: 'NORMAL_PNL_DEDUCT' },
  { label: '任务盈亏抵扣券', value: 'TASK_PNL_DEDUCT' },
  { label: '普通代币券', value: 'NORMAL_TOKEN' },
  { label: '任务代币券', value: 'TASK_TOKEN' },
  { label: '普通仓位体验券', value: 'NORMAL_POSITION_EXPERIENCE' },
  { label: '任务仓位体验券', value: 'TASK_POSITION_EXPERIENCE' },
  { label: 'VIP体验卡', value: 'TASK_VIP' },
]

export const COUPON_TYPE_MAP = {
  NORMAL_EXPERIENCE: '普通体验金',
  TASK_EXPERIENCE: '任务体验金',
  NORMAL_FEE_DEDUCT: '普通手续费抵扣券',
  TASK_FEE_DEDUCT: '任务手续费抵扣券',
  NORMAL_PNL_DEDUCT: '普通盈亏抵扣券',
  TASK_PNL_DEDUCT: '任务盈亏抵扣券',
  NORMAL_TOKEN: '普通代币券',
  TASK_TOKEN: '任务代币券',
  NORMAL_POSITION_EXPERIENCE: '普通仓位体验券',
  TASK_POSITION_EXPERIENCE: '任务仓位体验券',
  TASK_VIP: 'VIP体验卡',
}

// 「待领取」、「已领取-发放成功」、「已领取发-发放失败」、「使用中」、「已使用」、「已过期」、「已回收」。
export const COUPON_STATUS_OPTIONS = [
  { label: '待领取', value: 'WAIT_RECEIVE' },
  // { label: '发放中', value: 'GRANTING' },
  { label: '已领取-发放成功', value: 'RECEIVE_SUCCESS' },
  { label: '已领取-发放失败', value: 'RECEIVE_FAILED' },
  { label: '使用中', value: 'USING' },
  { label: '已使用', value: 'USED' },
  // { label: '回收中', value: 'RECYCLING' },
  { label: '已过期', value: 'EXPIRED' },
  { label: '已回收', value: 'RECYCLED' },
]

export const COUPON_STATUS_MAP = COUPON_STATUS_OPTIONS.reduce((result, item) => {
  result[item.value] = item.label
  return result
}, {})
